<template>
  <div class="container-list">
    <div class="common-page common-head">
      <div class="common-page common-head-title">
        <i class="icon-tr--detailed"></i>
        巡查人员管理
      </div>
      <!--            <div class="common-page common-head-end" @click="$router.back()">-->
      <!--                <i class="icon-tr-sign-out"></i>-->
      <!--            </div>-->
    </div>
    <!-- <ul class="tab-wrap" style="border:none" >
      <li
        :class="`tab-btn ${nowIndex == index && 'active'}`"
        @click="changeTab(index,tab)"
        v-for="(tab, index) in tabList"
      >
        {{tab.name }}
      </li>
    </ul> -->
    <div class="common-page common-body commonBtn">
      <div class="common-page common-tool-bar btnLeft">
        <div  class="btn" @click="showDia = true"><i class="icon-tr-search"></i>查询</div>
        <!-- v-hasPermi="['safe:user:query']" -->
         <!--  -->
        <router-link
         v-hasPermi="['relic:inspectionUser:add']"
          class="btn ml20"
          :to="{
            path: '/wenlv/inspectionAddPerson',
            query: { inspection: 3 },
          }"
        >
          <i class="icon-tr-newly-added"> </i> 新增</router-link
        >
      </div>
      <div class="common-page common-list" style="margin: 0">
        <el-table :data="list" class="mt10">
          <el-table-column prop="userName" label="登录账号" align="center"> </el-table-column>
          <el-table-column prop="nickName" align="center" label="真实姓名"> </el-table-column>
          <el-table-column prop="phoneNumber" align="center" label="手机号"> </el-table-column>
          <!-- <el-table-column align="center" label="巡查区域">
            <template slot-scope="scope">
              {{ scope.row.x_company_area == '' ? '暂无数据' : scope.row.x_company_area }}
            </template>
          </el-table-column> -->
          <!-- <el-table-column prop="STATUS" align="center" label="标签类型">
            <template slot-scope="scope">
              {{ scope.row.NFCStr }}
            </template>
          </el-table-column> -->
          <el-table-column prop="status" align="center" label="状态">
            <template slot-scope="scope">
              <p v-if="scope.row.status==0">停用</p>
              <p v-if="scope.row.status==1">正常</p>
              <!-- {{ $map.menuStatus[scope.row.status] }} -->
            </template>
          </el-table-column>
          <el-table-column label="操作" align="center" width="360px">
            <template slot-scope="scope">
              <!--  -->
              <router-link
                v-hasPermi="['relic:inspectionUser:edit']"
                :to="{
                  path: '/wenlv/inspectionPersonEdit',
                  query: {
                    id: scope.row.userId,
                    inspection: tabList[nowIndex].id == 0 ? 1 : 2,
                  },
                }"
              >
                <el-button type="warning" size="mini">编辑</el-button>
              </router-link>
              <!--  -->
              <el-popconfirm title="确定此删除该单位吗？" class="cursor"  @confirm="changeStatus(scope.row)" @onConfirm="changeStatus(scope.row)" >
                <a slot="reference" class="red" >
                  <!-- v-if="scope.row.status == 1" -->
                  <el-button type="danger" size="mini" v-hasPermi="['relic:inspectionUser:remove']">删除</el-button>
                </a>
                <!-- <a slot="reference" class="blue" v-if="scope.row.status != 1">
                  开启
                </a> -->
              </el-popconfirm>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <el-dialog title="查询" :visible.sync="showDia" :close-on-click-modal="false">
        <fm-generate-form :data="searchForm" :remote="remoteFuncs" :value="editData" ref="searchForm" v-if="tabList[nowIndex].id == 0"> </fm-generate-form>
        <fm-generate-form :data="searchForm1" :remote="remoteFuncs" :value="editData" v-if="tabList[nowIndex].id == 1" ref="searchForm"> </fm-generate-form>
        <div class="center">
          <el-button type="primary" @click="searchSubmit" size="small">确定</el-button>
          <el-button @click="cancle" size="small">重置</el-button>
        </div>
      </el-dialog>
    </div>
    <div style="margin-right: .9375rem;">
      <el-pagination background layout="prev, pager, next" :page-size="10" @current-change="pageChange" :total="total"> </el-pagination>
      <!-- <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="params.page"
        :page-sizes="[10, 20, 30, 40]"
        :page-size="params.limit || 10"
        layout=" prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination> -->
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      list: [],
      tabList: this.$store.state.user.userInfo.isWenwu ? [{ name: '文物巡查', id: 1 }] : [{ name: '消防巡查', id: 0 }],

      nowIndex: 0,
      params: {
        pageNum: 1,
        pageSize: 10,
        nickName: '',
        userName: '',
        x_company_area: '',
        inspectionType: 3,
      },
      total: 0,
      showDia: false,
      // ,
        // {
        //   "type": "select",
        //   "icon": "icon-select",
        //   "options": {
        //     "defaultValue": "",
        //     "multiple": false,
        //     "disabled": false,
        //     "clearable": true,
        //     "placeholder": "",
        //     "required": false,
        //     "showLabel": true,
        //     "width": "",
        //     "options": [{ "value": "Option 1" }, { "value": "Option 2" }, { "value": "Option 3" }],
        //     "remote": true,
        //     "filterable": false,
        //     "remoteOptions": [],
        //     "props": { "value": "areaId", "label": "areaName" },
        //     "remoteFunc": "getArea"
        //   },
        //   "name": "巡查区域",
        //   "key": "1645507608000_87704",
        //   "model": "areaName",
        //   "rules": []
        // }
      searchForm: this.$getForm('userSearch1'),
      searchForm1: this.$getForm('userSearchww'),
      // ,
      //   {
      //     "type": "select",
      //     "icon": "icon-select",
      //     "options": {
      //       "defaultValue": "",
      //       "multiple": false,
      //       "disabled": false,
      //       "clearable": true,
      //       "placeholder": "",
      //       "required": false,
      //       "showLabel": false,
      //       "width": "",
      //       "options": [{ "value": "Option 1" }, { "value": "Option 2" }, { "value": "Option 3" }],
      //       "remote": true,
      //       "filterable": true,
      //       "remoteOptions": [],
      //       "props": { "value": "areaId", "label": "areaName" },
      //       "remoteFunc": "getWWArea"
      //     },
      //     "name": "巡查区域",
      //     "key": "1656396483000_35048",
      //     "model": "areaName",
      //     "rules": []
      //   }
      allData: null,
      editData: {},
      remoteFuncs: {
        _this: this,
        getArea(resolve) {
          var _this = this._this;
          let c_num = _this.$store.state.user.company.cCompanyNum || "";
          _this.$get(
                "/relic/relicInspectionCompanyArea/listNotPage?companyNum=" + c_num
                ).then((res) => {
                  console.log(res,1111111);
                resolve(res.data)
                });
          // _this
          //   .$post('/xuncha/xunchaareadetail', {
          //     c_company_num: _this.$store.state.user.company.cCompanyNum,
          //   })
          //   .then((res) => {
          //     resolve(res.data);
          //   });
        },
        getWWArea(resolve) {
          var _this = this._this;
          _this.$get(
                "/relic/relicInspectionCompanyArea/listNotPage?companyNum=" + c_num
                ).then((res) => {
  
                resolve(res.data)
                });
          // _this
          //   .$post('/xuncha/xunchaareadetailWenWu', {
          //     c_company_num: _this.$store.state.user.company.cCompanyNum,
          //   })
          //   .then((res) => {
          //     resolve(res.data);
          //   });
        },
      },
    };
  },
  created() {
    // this.params.inspectionType = 3;
    this.getList();
  },
  methods: {
    cancle() {
      // this.showDia=false
      this.resetSearch();
    },
    changeTab(index, it) {
      this.nowIndex = index;
      this.params = {
        currentpage: 1,
        user_name: '',
        nick_name: '',
        x_company_area: '',
        inspectionType:3,
      };
      this.getList();
    },
    changeStatus(it, del) {
      console.log(it,'it');
      this.$remove('/relic/inspectionUser/'+it.userId).then((res) => {
        this.$message({
                message: '操作成功',
                type: 'success',
                duration: 700,
              });
        this.getList();
      });
    },

    getList() {

   
      this.$get('/relic/inspectionUser/list', this.params).then((res) => {
        // console.log(res,3333);

        this.total = res.total;
        this.list = res.rows;
      });
    },
    pageChange(index) {
     
      this.params.pageNum = index;
      this.params.inspectionType = 3;
      this.getList();
    },
    searchSubmit() {
      this.$refs.searchForm
        .getData()
        .then((data) => {
          //log(data)
          this.params = { ...this.params, ...data };
          this.params.pageNum = 1;

          this.getList();
          this.showDia = false;
        })
        .catch((e) => {});
    },
    resetSearch() {
      this.$refs.searchForm.reset();
      this.params = { ...this.params, ...this.$refs.searchForm.models };
      this.getList();
    },
  },
};
</script>

<style scoped>
.container-list {
  width: 100%;
  height: 100%;
}
.common-tool-bar {
  width: 100%;
  display: flex;
}
.btnLeft {
  margin: 0 -40px;
}
</style>
